<div>
  <h3 class="pr-16 m-b-0 cardHeader f-l" matDialogTitle>Atributos múltiples</h3>
  <div>
    <button mat-icon-button (click)="Add()" class="f-r" [disabled]="Operation==='Edit'">
      <mat-icon class="mat-icon material-icons mat-icon-no-color f-s-19">add</mat-icon>
    </button>
  </div>
</div>

<div>
  <table class="mat-table multi-att">
    <caption></caption>
    <thead>
      <tr class="mat-header-row">
        <th id="valor" class="w-200-add-attribute mat-header-cell">Valor</th>
        <th id="porcentaje" class="w-100-attribute mat-header-cell">Porcentaje</th>
        <th id="" class="mat-header-cell"></th>
      </tr>
    </thead>
    <tbody>
      <tr class="mat-header-row" *ngFor="let row of KeyValueArray">
        <td class="mat-cell">{{row.key}}</td>
        <td class="mat-cell">{{row.value}}</td>
        <td class="table-icon mat-cell text-right">
          <em (click)="Edit(row)" class="mat-icon material-icons mat-icon-no-color f-s-19">edit</em>
          <em class="mat-icon material-icons mat-icon-no-color f-s-19" (click)="Delete(row)">delete_forever</em>
        </td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="ShowEditPanel">
    <form [formGroup]="PercentageForm" class="display-flex m-t-10">
      <div class="w-200-add-attribute">
        <mat-form-field class="example-full-width w-200 m-r-10" floatLabel="always">
          <input matInput placeholder="Valor" formControlName="key">
        </mat-form-field>
        <mat-error class="m-t--13 p-b-3"
          *ngIf="(PercentageForm.get('key').dirty || PercentageForm.get('key').touched ) && PercentageForm.get('key').invalid">
          <span *ngIf="PercentageForm.get('key').errors.required" class="validation-span">Obligatorio</span>
        </mat-error>
      </div>
      <div>
        <mat-form-field class="example-full-width w-100 m-r-10" floatLabel="always">
          <input matInput placeholder="Porcentaje" formControlName="value">
        </mat-form-field>
        <mat-error class="m-t--13 p-b-3"
          *ngIf="(PercentageForm.get('value').dirty || PercentageForm.get('value').touched ) && PercentageForm.get('value').invalid">
          <span *ngIf="PercentageForm.get('value').errors.required" class="validation-span">Obligatorio</span>
          <span *ngIf="PercentageForm.get('value').errors.NotAPercentageValue" class="validation-span">Porcentaje
            inválido</span>
        </mat-error>
      </div>
      <div class="confirm-div"><button mat-raised-button class="mat-primary m-r-10 w-150 confirm-btn"
          (click)="Confirm()">Confirmar</button></div>
    </form>
  </div>
</div>

<div class="text-a-r p-t-15">
  <button mat-raised-button class="mat-accent m-r-10" (click)="Accept()">Aceptar</button>
  <button mat-raised-button color="warn" (click)="Cancel()">Cancelar</button>
</div>